import type {
  PortfolioEintrag,
  PortfolioKlasse,
  PortfolioProdukt,
} from "../../services/partnerPortfolioService";
/** Nur leere inaktive Arten ausblenden: bestehende Produkte bleiben im Entwurf. */
export function gruppierePortfolio<
  T extends Pick<PortfolioEintrag, "insuranceProductId">,
>(
  klassen: PortfolioKlasse[],
  produkte: PortfolioProdukt[],
  eintraege: T[],
  nurAngebotene: boolean,
) {
  const sortiert = [...klassen].sort(
    (a, b) =>
      a.sortOrder - b.sortOrder ||
      a.insuranceClass.localeCompare(b.insuranceClass, "de"),
  );
  const bekannteIds = new Set(klassen.map((k) => k.id));
  for (const p of produkte)
    if (!bekannteIds.has(p.insuranceClassID)) {
      bekannteIds.add(p.insuranceClassID);
      sortiert.push({
        id: p.insuranceClassID,
        insuranceClass: "Weitere Vertragsarten",
        sortOrder: 0,
        active: true,
      });
    }
  return sortiert
    .map((k) => ({
      id: k.id,
      name: k.insuranceClass,
      arten: produkte
        .filter((p) => p.insuranceClassID === k.id)
        .sort(
          (a, b) =>
            a.sortOrder - b.sortOrder || a.name.localeCompare(b.name, "de"),
        )
        .map((produkt) => ({
          produkt,
          eintraege: eintraege.filter(
            (e) => e.insuranceProductId === produkt.id,
          ),
        }))
        .filter(
          (a) =>
            (a.produkt.active !== false || a.eintraege.length > 0) &&
            (!nurAngebotene || a.eintraege.length > 0),
        ),
    }))
    .filter((k) => k.arten.length > 0);
}
